<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
*{
    padding: 0;
    margin: 0;
    text-decoration: none;
    cursor: url(./assets/pointer_hand_0001_44x41.png), default;
    -webkit-user-select: none; /* Chrome, Opera, Safari */
    -moz-user-select: none;    /* Firefox */
    -ms-user-select: none;    /* Internet Explorer/Edge */
    user-select: none; 
   
  }
  :active{
    cursor: url(./assets/pointer_hand_0002_44x41.png), default;
  }
  /* ::-webkit-scrollbar{
  display:none;
  }  */
/* 定义滚动条样式 */
  #app::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background: rgba(29,29,38,.7);
}
/*定义滚动条轨道*/
#app::-webkit-scrollbar-track {
		box-shadow: inset 0 0 0px rgba(240, 240, 240, .5);
		border-radius: 10px;
		background: rgba(29,29,38,.7);
}
/*定义滑块*/
#app::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 0px rgba(118, 118, 118, 0.5);
		background-color: rgba(118, 118, 118, 0.5);
}
</style>
